import React, { useState, useEffect, useRef } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import "../css/TopBar.css";
import { useDispatch, useSelector } from "react-redux";
import { setSelectedModel } from "../redux/modelSlice";
import profileIcon from "../assets/icons/profileIcon.png";
import settingIcon from "../assets/icons/settingIcon.png";
import helpIcon from "../assets/icons/helpIcon.png";
import logoutIcon from "../assets/icons/logoutIcon.png";
import { resetSidebarState, setSelectedMenu } from "../redux/sidebarSlice"; // ✅ add this
import { toggleTheme } from "../redux/themeSlice";
import api from "../api";

const savedDarkMode = localStorage.getItem("darkMode") === "true";
document.documentElement.setAttribute(
  "data-theme",
  savedDarkMode ? "dark" : "light"
);
document.body.classList.toggle("dark-mode", savedDarkMode);

const SuperadminTopbar = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const profileRef = useRef(null); // 👈 wrapper ref
  const selectedModel = useSelector((state) => state.model.selectedModel);
  const selectedMenu = useSelector((state) => state.sidebar.selectedMenu);

  const [showProfileMenu, setShowProfileMenu] = useState(false);
  const [user, setUser] = useState(null);
  const token =
    localStorage.getItem("access_token") ||
    sessionStorage.getItem("access_token");

  const theme = useSelector((state) => state.theme.mode);
  // const [darkMode, setDarkMode] = useState(() => {
  //   return localStorage.getItem("theme") === "dark";
  // });

  const [darkMode, setDarkMode] = useState(
    localStorage.getItem("darkMode") === "true"
  );

  const toggleDarkMode = () => {
    setDarkMode((prev) => {
      const newMode = !prev;
      localStorage.setItem("darkMode", newMode);
      document.documentElement.setAttribute(
        "data-theme",
        newMode ? "dark" : "light"
      );
      return newMode;
    });
  };

  // Map for dropdown pages
  const profileRoutes = {
    "/superadmin/profile": "Profile",
    "/superadmin/getHelp": "Get Help",
  };

  const currentPath = location.pathname;

  // If route is profile dropdown, show its title, else show sidebar menu
  const pageTitle = profileRoutes[currentPath] || selectedMenu;

  const handleLogout = async () => {
    try {
      // ✅ Call backend logout API
      await api.post(`${process.env.REACT_APP_API_URL}/auth/logout-device`, {
        headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
      });

      // ✅ Clear localStorage & sessionStorage
      localStorage.removeItem("token");
      localStorage.removeItem("user");
      sessionStorage.removeItem("token");
      sessionStorage.removeItem("user");

      // ✅ Reset Redux / UI state
      dispatch(resetSidebarState());

      // ✅ Redirect to login page
      navigate("/");
    } catch (err) {
      console.error("Logout failed:", err);
      // Optional: show toast/error notification to user
    }
  };

  // useEffect(() => {
  //   if (darkMode) {
  //     document.body.classList.add("dark-mode");
  //     localStorage.setItem("theme", "dark");
  //   } else {
  //     document.body.classList.remove("dark-mode");
  //     localStorage.setItem("theme", "light");
  //   }
  // }, [darkMode]);

  const toggleProfileMenu = () => setShowProfileMenu(!showProfileMenu);
  const closeMenu = () => setShowProfileMenu(false);
  // const toggleDarkMode = () => setDarkMode(!darkMode);

  // 👇 Close on outside click
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (profileRef.current && !profileRef.current.contains(event.target)) {
        setShowProfileMenu(false);
      }
    };

    if (showProfileMenu) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [showProfileMenu]);

  const handleThemeToggle = () => {
    dispatch(toggleTheme());
  };

  useEffect(() => {
    document.body.classList.toggle("dark-mode", theme === "dark");
  }, [theme]);

  useEffect(() => {
    if (!selectedModel) {
      dispatch(setSelectedModel("LLaMA3.2"));
    }
  }, [dispatch, selectedModel]);

  // ✅ Fetch user profile from API
  useEffect(() => {
    const fetchUserProfile = async () => {
      try {
        const res = await api.get(
          `${process.env.REACT_APP_API_URL}/user-profile/profile`,
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        );
        setUser(res.data);
      } catch (err) {
        console.error("Failed to fetch user profile:", err);
      }
    };

    if (token) fetchUserProfile();
  }, [token]);

  return (
    <div>
      <nav className="topbar navbar navbar-expand-lg px-3 shadow-sm d-flex justify-content-between align-items-center">
        <div className="topbar-left">
          <h4 className="m-0 refresh-prompts fw-bold">{selectedMenu}</h4>
        </div>
        <div className="d-flex align-items-center gap-3 ms-auto position-relative">
          {/* <Link to="notifications" className="btn hi btn-link text-dark p-0">
            <i className="bi bi-bell fs-5"></i>
          </Link> */}

          <button
            className="hi border-0"
            onClick={toggleDarkMode}
            title="Toggle Theme"
            style={{
              width: "28px",
              height: "28px",
              borderRadius: "50%",
              backgroundColor: "#3e3e3e",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              padding: "0",
            }}
          >
            <i
              className={`bi ${darkMode ? "bi-moon" : "bi-sun"} textwhite`}
              style={{ fontSize: "15px" }}
            />
          </button>

          <div className="position-relative" ref={profileRef}>
            {/* <button
              className="p-0 border-0 bg-transparent"
              onClick={toggleProfileMenu}
            >
              <img
                src="https://cdn-icons-png.flaticon.com/512/3135/3135715.png"
                className="rounded-circle"
                alt="Avatar"
                style={{ width: "25px", height: "25px" }}
              />
            </button> */}
            <button
              className="p-0 border-0 bg-transparent"
              onClick={toggleProfileMenu}
            >
              {user?.user_profile_pic ? (
                <img
                  src={`${
                    process.env.REACT_APP_SERVER_URL
                  }/${user.user_profile_pic.replace(/\\/g, "/")}`}
                  alt="Profile"
                  className="rounded-circle"
                  style={{ width: "28px", height: "28px", objectFit: "cover" }}
                />
              ) : (
                <div
                  className="rounded-circle bg-dark text-white d-flex align-items-center justify-content-center"
                  style={{ width: "28px", height: "28px", fontSize: "12px" }}
                >
                  {user?.user_name?.charAt(0).toUpperCase() || "U"}
                </div>
              )}
            </button>

            {showProfileMenu && (
              <div
                className="dropdown-menu profile-dropdown show profile-dropdown"
                onMouseLeave={closeMenu}
              >
                <Link
                  className="dropdown-item profile-dropdown-item d-flex align-items-center border-bottom gap-2"
                  to="profile"
                  onClick={() =>
                    dispatch(setSelectedMenu(""))
                  } /* clear sidebar selection */
                >
                  <img
                    src={profileIcon}
                    alt="Profile Img"
                    className="Profile-Svg icon-image"
                  />{" "}
                  <span className="Profile-text refresh-prompts">Profile</span>
                </Link>
                {/* <Link
                  className="dropdown-item d-flex align-items-center gap-2"
                  to="/settings"
                >
                  <img
                    src={settingIcon}
                    alt="Profile Img"
                    className="Profile-Svg"
                  />{" "}
                  <span className="Profile-text">Settings</span>
                </Link> */}
                {/* <Link
                  className="dropdown-item d-flex align-items-center gap-2"
                  to="/superadmin/getHelp"
                  onClick={() =>
                    dispatch(setSelectedMenu(""))
                  }
                >
                  <img src={helpIcon} alt="Help Icon" className="Profile-Svg" />
                  <span className="Profile-text">Get Help</span>
                </Link> */}
                <button
                  className="dropdown-item profile-dropdown-item d-flex align-items-center gap-2"
                  onClick={handleLogout}
                >
                  <img
                    src={logoutIcon}
                    alt="Profile Img"
                    className="Profile-Svg icon-image"
                  />{" "}
                  <span className="Profile-text refresh-prompts">Logout</span>
                </button>
              </div>
            )}
          </div>
        </div>
      </nav>
    </div>
  );
};

export default SuperadminTopbar;
